// The hook hoc
// A higher-order component that injects a hook api into a class component
// allowing mapping incoming props to hook arguments.
export const withHook =
  (useHook, hookPropName, hookPropFn) => (WrappedComponent) => (props) => {
    const hookArgs = typeof hookPropFn === 'function' ? hookPropFn(props) : [];
    const hookAPI = useHook(...hookArgs);
    const hookProp = { [hookPropName]: hookAPI };
    return <WrappedComponent {...props} {...hookProp} />;
  };
